export const waitForVariable = (condition: () => boolean) => {
  return new Promise((resolve) => {
    const checkVariable = () => {
      if (condition()) {
        resolve(true);
      } else {
        setTimeout(checkVariable, 100);
      }
    };

    checkVariable();
  });
};
